// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset and normalize_ */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  vertical-align: baseline;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-weight: inherit;
  font-style: inherit;
  font-size: 100%;
  font-family: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}
ol,
ul {
  list-style: none;
}
table {
  vertical-align: top;
  border-spacing: 0;
  border-collapse: collapse;
  table-layout: fixed;
}
caption,
th,
td {
  vertical-align: top;
  font-weight: normal;
  text-align: left;
}
a img {
  border: none;
}
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
main {
  display: block;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}
audio,
canvas,
video {
  display: inline-block;
  *display: inline;
  *zoom: 1;
}
audio:not([controls]) {
  display: none;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
video {
  display: inline-block;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden] {
  display: none;
}
html {
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}
a:focus,
a:active,
a:hover {
  outline: 0;
}
b,
strong {
  font-weight: bold;
}
dfn {
  font-style: italic;
}
mark {
  color: #000;
}
code,
kbd,
pre,
samp {
  font-size: 1em;
  font-family: monospace, serif;
}
pre {
  white-space: pre-wrap;
}
q {
  quotes: '\\00ab' '\\00bb';
}
q q {
  quotes: '\\201e' '\\201c';
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  vertical-align: top;
  border: none;
}
.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}
legend {
  padding: 0;
  border: 0;
}
button,
input,
select,
textarea {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  outline: none;
  font-size: 100%;
  font-family: inherit;
}
button,
input {
  line-height: normal;
}
button,
select {
  text-transform: none;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  button {
    overflow: visible;
  }
}
button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
  cursor: pointer;
  -webkit-appearance: button;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
}
input[type='search'] {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-appearance: textfield;
}
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  padding: 0;
  border: 0;
}
textarea {
  vertical-align: top;
  overflow: auto;
}
a {
  text-decoration: none;
}
:root {
  --primary-color: #73FBFD;
  --gray: #5F5F5F;
  --light-gray: #b6b4b4;
  --dark-primary-color: #1A3750;
  --blue: #07456F;
  --error: #e51155;
}
@font-face {
  font-weight: normal;
  font-style: normal;
  font-family: 'SB Sans Text';
  src: url('assets/fonts/SB Sans Text.woff2') format('woff2'), url('assets/fonts/SB Sans Text.woff') format('woff');
  font-display: swap;
}
@font-face {
  font-weight: bold;
  font-style: normal;
  font-family: 'SB Sans Text';
  src: url('assets/fonts/SB Sans Text Bold.woff2') format('woff2'), url('assets/fonts/SB Sans Text Bold.woff') format('woff');
  font-display: swap;
}
@font-face {
  font-weight: normal;
  font-style: normal;
  font-family: 'SB Sans Interface';
  src: url('assets/fonts/SB Sans Interface.woff2') format('woff2'), url('assets/fonts/SB Sans Interface.woff') format('woff');
  font-display: swap;
}
@font-face {
  font-weight: 600;
  font-style: normal;
  font-family: 'SB Sans Interface';
  src: url('assets/fonts/SB Sans Interface Bold.woff2') format('woff2'), url('assets/fonts/SB Sans Interface Bold.woff') format('woff');
  font-display: swap;
}
html {
  font-weight: 400;
  font-size: 0.0732vw;
  font-family: 'SB Sans Text', sans-serif;
}
body {
  background-color: #000;
  color: #fff;
}
.main {
  overflow: hidden;
}
.main.loaded-done .section-title[visible] {
  opacity: 1;
  transform: translateY(0);
}
.index__decor-wrap {
  width: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  z-index: -1;
}
.index__decor {
  position: absolute;
  z-index: -1;
}
.index__decor--1 {
  top: -74rem;
  left: 0;
  width: 928rem;
}
.index__decor--2 {
  top: 0;
  right: 0;
  width: 1082rem;
}
.index__decor--3 {
  top: 900rem;
  left: 0;
  width: 1127rem;
}
.index__decor--4 {
  top: 1550rem;
  right: 0;
  width: 1106rem;
}
.ant-collapse {
  border: none;
  border-radius: 0%;
}
.ant-collapse > .ant-collapse-item {
  border: none;
  border-bottom: 1px solid #4ba8a9;
}
.ant-collapse > .ant-collapse-item:last-child {
  border-bottom-right-radius: 0%;
  border-bottom-left-radius: 0%;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  align-items: center;
}
.ant-collapse-expand-icon,
.ant-collapse-header-text {
  color: white;
  font-size: 16rem;
}
.collapse__content {
  font-size: 13rem;
  margin-bottom: 10px;
  margin-top: 10px;
}
.collapse__content_li {
  font-size: 13rem;
  margin-inline-start: 20rem;
  list-style-type: disc;
}
.collapse__content_li::marker {
  color: var(--primary-color);
}
.ant-collapse .ant-collapse-content {
  border: none;
  background-color: transparent;
  color: white;
}
.ant-result-extra {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-modal .ant-modal-content {
  padding: 23rem 16rem 16rem;
  border-radius: 20px;
}
.ant-modal .ant-modal-content .ant-modal-confirm-body .anticon-audit {
  color: var(--gray);
}
@media (max-width: 660px) {
  html {
    font-size: 0.2667vw;
  }
  .section-title {
    font-size: 25rem;
    line-height: 31rem;
  }
  .index__decor--1 {
    top: -55rem;
    width: 370rem;
  }
  .index__decor--2 {
    width: 375rem;
  }
  .index__decor--3 {
    top: 1070rem;
    width: 375rem;
  }
  .index__decor--4 {
    top: 2628rem;
    width: 375rem;
  }
  .index__decor--5 {
    top: 3428rem;
    right: 0;
    width: 375rem;
  }
  .index__decor--6 {
    top: 4628rem;
    left: 0;
    width: 375rem;
  }
  .index__decor--7 {
    right: 0;
    bottom: -344rem;
    width: 375rem;
  }
  .ant-collapse-expand-icon,
  .ant-collapse-header-text {
    font-size: 10rem;
  }
  .collapse__content {
    font-size: 8rem;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
.ant-col.ant-form-item-label > label {
  /* Inside auto layout */
  flex: none;
  flex-grow: 0;
  align-self: stretch;
  order: 0;
  /* Field [Light]/Label-Filled */
  color: var(--gray);
  /* Inner Space / Sm Regular */
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  /* identical to box height, or 123% */
  letter-spacing: -0.3px;
}
.ant-modal .ant-modal-close {
  top: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/index.style.less","webpack://./src/app/styles/reset.style.less","webpack://./src/app/styles/variables.style.less","webpack://./src/app/styles/fonst.style.less"],"names":[],"mappings":"AAAA,yBAAyB;ACCzB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAyDI,wBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,6CAAA;EACA,wCAAA;ADCJ;ACEA;;;EAGI,sBAAA;ADAJ;ACGA;;EAEI,gBAAA;ADDJ;ACIA;EACI,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;ADFJ;ACKA;;;EAGI,mBAAA;EACA,mBAAA;EACA,gBAAA;ADHJ;ACMA;EACI,YAAA;ADJJ;ACOA;;;;;;;;;;;;;;EAcI,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ADLJ;ACQA;;;EAGI,qBAAA;GACA,eAAA;GACA,OAAA;ADNJ;ACSA;EACI,aAAA;ADPJ;ACUA;;;;;;;;;;;;EAYI,cAAA;ADRJ;ACWA;;;EAGI,qBAAA;ADTJ;ACYA;EACI,aAAA;EACA,SAAA;ADVJ;ACaA;EACI,aAAA;ADXJ;ACcA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;ADZJ;ACeA;;;EAGI,UAAA;ADbJ;ACgBA;;EAEI,iBAAA;ADdJ;ACiBA;EACI,kBAAA;ADfJ;ACkBA;EACI,WAAA;ADhBJ;ACmBA;;;;EAII,cAAA;EACA,6BAAA;ADjBJ;ACoBA;EACI,qBAAA;ADlBJ;ACqBA;EACI,uBAAA;ADnBJ;ACsBA;EACI,uBAAA;ADpBJ;ACuBA;EACI,cAAA;ADrBJ;ACwBA;;EAEI,kBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;ADtBJ;ACyBA;EACI,WAAA;ADvBJ;AC0BA;EACI,eAAA;ADxBJ;AC2BA;EACI,mBAAA;EACA,YAAA;ADzBJ;AC4BA;EACI,cAAA;EACA,eAAA;EACA,YAAA;AD1BJ;AC6BA;EACI,gBAAA;AD3BJ;AC8BA;EACI,SAAA;AD5BJ;AC+BA;EACI,SAAA;EACA,UAAA;EACA,SAAA;AD7BJ;ACgCA;EACI,UAAA;EACA,SAAA;AD9BJ;ACiCA;;;;EAII,8BAAA;EACA,2BAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AD/BJ;ACkCA;;EAEI,mBAAA;ADhCJ;ACmCA;;EAEI,oBAAA;ADjCJ;ACoCA;EACI;IACI,iBAAA;EDlCN;AACF;ACqCA;;;;EAII,eAAA;EACA,0BAAA;ADnCJ;ACsCA;;EAEI,eAAA;ADpCJ;ACuCA;;EAEI,8BAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;ADrCJ;ACwCA;EACI,+BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;ADtCJ;ACyCA;;EAEI,wBAAA;ADvCJ;AC0CA;;EAEI,UAAA;EACA,SAAA;ADxCJ;AC2CA;EACI,mBAAA;EACA,cAAA;ADzCJ;AC4CA;EACI,qBAAA;AD1CJ;AE7QA;EACI,wBAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AF+QJ;AG9SA;EACI,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,iHAAA;EACA,kBAAA;AHgTJ;AG7SA;EACI,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,2HAAA;EACA,kBAAA;AH+SJ;AG5SA;EACI,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2HAAA;EACA,kBAAA;AH8SJ;AG3SA;EACI,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,qIAAA;EACA,kBAAA;AH6SJ;AArUA;EACI,gBAAA;EACA,mBAAA;EACA,uCAAA;AAuUJ;AApUA;EACI,sBAAA;EACA,WAAA;AAsUJ;AAnUA;EACI,gBAAA;AAqUJ;AAlUA;EACI,UAAA;EACA,wBAAA;AAoUJ;AA7TA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AA+TJ;AA5TA;EACI,kBAAA;EACA,WAAA;AA8TJ;AA3TA;EACI,WAAA;EACA,OAAA;EACA,aAAA;AA6TJ;AA1TA;EACI,MAAA;EACA,QAAA;EACA,cAAA;AA4TJ;AAzTA;EACI,WAAA;EACA,OAAA;EACA,cAAA;AA2TJ;AAxTA;EACI,YAAA;EACA,QAAA;EACA,cAAA;AA0TJ;AAvTA;EACI,YAAA;EACA,iBAAA;AAyTJ;AAtTA;EACI,YAAA;EACA,gCAAA;AAwTJ;AArTA;EACI,8BAAA;EACA,6BAAA;AAuTJ;AApTA;EACI,mBAAA;AAsTJ;AAnTA;;EAEI,YAAA;EACA,gBAAA;AAqTJ;AAlTA;EACI,gBAAA;EACA,mBAAA;EACA,gBAAA;AAoTJ;AAjTA;EACI,gBAAA;EACA,0BAAA;EACA,qBAAA;AAmTJ;AAlTI;EACI,2BAAA;AAoTR;AAhTA;EACI,YAAA;EACA,6BAAA;EACA,YAAA;AAkTJ;AA/SA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAiTJ;AA9SA;EACI,0BAAA;EACA,mBAAA;AAgTJ;AAlTA;EAMY,kBAAA;AA+SZ;AA1SA;EACI;IACI,mBAAA;EA4SN;EAzSE;IACI,gBAAA;IACA,kBAAA;EA2SN;EAxSE;IACI,WAAA;IACA,aAAA;EA0SN;EAvSE;IACI,aAAA;EAySN;EAtSE;IACI,YAAA;IACA,aAAA;EAwSN;EArSE;IACI,YAAA;IACA,aAAA;EAuSN;EApSE;IACI,YAAA;IACA,QAAA;IACA,aAAA;EAsSN;EAnSE;IACI,YAAA;IACA,OAAA;IACA,aAAA;EAqSN;EAlSE;IACI,QAAA;IACA,eAAA;IACA,aAAA;EAoSN;EAjSE;;IAEI,gBAAA;EAmSN;EAhSE;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;EAkSN;AACF;AA/RA;EAiSE,uBAAuB;EA/RrB,UAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EAiSF,+BAA+B;EA9R7B,kBAAA;EAgSF,6BAA6B;EA5R3B,gBAAA;EACA,eAAA;EACA,iBAAA;EA8RF,qCAAqC;EA3RnC,sBAAA;AA6RJ;AAzRA;EACI,QAAA;AA2RJ","sourcesContent":["@import url('./reset.style.less');\n@import url('./variables.style.less');\n@import url('./fonst.style.less');\n\n\nhtml {\n    font-weight: 400;\n    font-size: .0732vw;\n    font-family: 'SB Sans Text', sans-serif;\n}\n\nbody {\n    background-color: #000;\n    color: #fff;\n}\n\n.main {\n    overflow: hidden;\n}\n\n.main.loaded-done .section-title[visible] {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.index {\n    // position: relative;\n}\n\n.index__decor-wrap {\n    width: 100%;\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    z-index: -1;\n}\n\n.index__decor {\n    position: absolute;\n    z-index: -1;\n}\n\n.index__decor--1 {\n    top: -74rem;\n    left: 0;\n    width: 928rem;\n}\n\n.index__decor--2 {\n    top: 0;\n    right: 0;\n    width: 1082rem;\n}\n\n.index__decor--3 {\n    top: 900rem;\n    left: 0;\n    width: 1127rem;\n}\n\n.index__decor--4 {\n    top: 1550rem;\n    right: 0;\n    width: 1106rem;\n}\n\n.ant-collapse {\n    border: none;\n    border-radius: 0%;\n}\n\n.ant-collapse > .ant-collapse-item {\n    border: none;\n    border-bottom: 1px solid #4ba8a9;\n}\n\n.ant-collapse > .ant-collapse-item:last-child {\n    border-bottom-right-radius: 0%;\n    border-bottom-left-radius: 0%;\n}\n\n.ant-collapse>.ant-collapse-item >.ant-collapse-header {\n    align-items: center;\n}\n\n.ant-collapse-expand-icon,\n.ant-collapse-header-text {\n    color: white;\n    font-size: 16rem;\n}\n\n.collapse__content {\n    font-size: 13rem;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n\n.collapse__content_li {\n    font-size: 13rem;\n    margin-inline-start: 20rem;\n    list-style-type: disc;\n    &::marker {\n        color: var(--primary-color);\n    }\n}\n\n.ant-collapse .ant-collapse-content {\n    border: none;\n    background-color: transparent;\n    color: white\n}\n\n.ant-result-extra {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ant-modal .ant-modal-content {\n    padding: 23rem 16rem 16rem;\n    border-radius: 20px;\n\n    .ant-modal-confirm-body {\n        .anticon-audit {\n            color: var(--gray);\n        }\n    }\n}\n\n@media (max-width: 660px) {\n    html {\n        font-size: .2667vw;\n    }\n\n    .section-title {\n        font-size: 25rem;\n        line-height: 31rem;\n    }\n\n    .index__decor--1 {\n        top: -55rem;\n        width: 370rem;\n    }\n\n    .index__decor--2 {\n        width: 375rem;\n    }\n\n    .index__decor--3 {\n        top: 1070rem;\n        width: 375rem;\n    }\n\n    .index__decor--4 {\n        top: 2628rem;\n        width: 375rem;\n    }\n\n    .index__decor--5 {\n        top: 3428rem;\n        right: 0;\n        width: 375rem;\n    }\n\n    .index__decor--6 {\n        top: 4628rem;\n        left: 0;\n        width: 375rem;\n    }\n\n    .index__decor--7 {\n        right: 0;\n        bottom: -344rem;\n        width: 375rem;\n    }\n\n    .ant-collapse-expand-icon,\n    .ant-collapse-header-text {\n        font-size: 10rem;\n    }\n\n    .collapse__content {\n        font-size: 8rem;\n        margin-bottom: 10px;\n        margin-top: 10px;\n    }\n}\n\n.ant-col.ant-form-item-label > label {\n    /* Inside auto layout */\n    flex: none;\n    flex-grow: 0;\n    align-self: stretch;\n    order: 0;\n  \n    /* Field [Light]/Label-Filled */\n    color: var(--gray);\n\n    /* Inner Space / Sm Regular */\n  \n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n\n    /* identical to box height, or 123% */\n    letter-spacing: -.3px;\n  \n}\n\n.ant-modal .ant-modal-close {\n    top: 7px;\n}\n  \n  \n  ","/* reset and normalize_ */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd {\n    vertical-align: baseline;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    font-weight: inherit;\n    font-style: inherit;\n    font-size: 100%;\n    font-family: inherit;\n    -webkit-tap-highlight-color: rgb(0 0 0 / 0);\n    -webkit-tap-highlight-color: transparent;\n}\n\n*,\n*:before,\n*:after {\n    box-sizing: border-box;\n}\n\nol,\nul {\n    list-style: none;\n}\n\ntable {\n    vertical-align: top;\n    border-spacing: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n}\n\ncaption,\nth,\ntd {\n    vertical-align: top;\n    font-weight: normal;\n    text-align: left;\n}\n\na img {\n    border: none;\n}\n\narticle,\naside,\ncanvas,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection,\nsummary,\nmain {\n    display: block;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n}\n\naudio,\ncanvas,\nvideo {\n    display: inline-block;\n    *display: inline;\n    *zoom: 1;\n}\n\naudio:not([controls]) {\n    display: none;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection,\nsummary {\n    display: block;\n}\n\naudio,\ncanvas,\nvideo {\n    display: inline-block;\n}\n\naudio:not([controls]) {\n    display: none;\n    height: 0;\n}\n\n[hidden] {\n    display: none;\n}\n\nhtml {\n    font-family: sans-serif;\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n}\n\na:focus,\na:active,\na:hover {\n    outline: 0;\n}\n\nb,\nstrong {\n    font-weight: bold;\n}\n\ndfn {\n    font-style: italic;\n}\n\nmark {\n    color: #000;\n}\n\ncode,\nkbd,\npre,\nsamp {\n    font-size: 1em;\n    font-family: monospace, serif;\n}\n\npre {\n    white-space: pre-wrap;\n}\n\nq {\n    quotes: '\\00ab' '\\00bb';\n}\n\nq q {\n    quotes: '\\201e' '\\201c';\n}\n\nsmall {\n    font-size: 80%;\n}\n\nsub,\nsup {\n    position: relative;\n    vertical-align: baseline;\n    font-size: 75%;\n    line-height: 0;\n}\n\nsup {\n    top: -.5em;\n}\n\nsub {\n    bottom: -.25em;\n}\n\nimg {\n    vertical-align: top;\n    border: none;\n}\n\n.img-responsive {\n    display: block;\n    max-width: 100%;\n    height: auto;\n}\n\nsvg:not(:root) {\n    overflow: hidden;\n}\n\nfigure {\n    margin: 0;\n}\n\nfieldset {\n    margin: 0;\n    padding: 0;\n    border: 0;\n}\n\nlegend {\n    padding: 0;\n    border: 0;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    outline: none;\n    font-size: 100%;\n    font-family: inherit;\n}\n\nbutton,\ninput {\n    line-height: normal;\n}\n\nbutton,\nselect {\n    text-transform: none;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    button {\n        overflow: visible;\n    }\n}\n\nbutton,\nhtml input[type='button'],\ninput[type='reset'],\ninput[type='submit'] {\n    cursor: pointer;\n    -webkit-appearance: button;\n}\n\nbutton[disabled],\nhtml input[disabled] {\n    cursor: default;\n}\n\ninput[type='checkbox'],\ninput[type='radio'] {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    padding: 0;\n}\n\ninput[type='search'] {\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n    -webkit-appearance: textfield;\n}\n\ninput[type='search']::-webkit-search-cancel-button,\ninput[type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n}\n\ntextarea {\n    vertical-align: top;\n    overflow: auto;\n}\n\na {\n    text-decoration: none;\n}\n","@os: 'SB Sans Text', sans-serif;\n@int: 'SB Sans Interface', sans-serif;\n@black: #000;\n\n@light-blue: #73FBFD;\n\n@dark-blue: #1A3750;\n\n@blue: #07456F;\n\n\n@cherry: rgba(229, 17, 85, 1);\n\n@gray: #5F5F5F;\n@light-gray: #b6b4b4;\n@text-link-color: #1677ff;\n@text-link-color-hover: #69b1ff;\n\n@mobile: '(max-width:660px)';\n@desktop: '(min-width:661px)';\n\n@ios: '(-webkit-overflow-scrolling: touch)';\n\n@ie: 'screen and (-ms-high-contrast: active), (-ms-high-contrast: none)';\n\n:root {\n    --primary-color: @light-blue;\n    --gray: @gray;\n    --light-gray: @light-gray;\n    --dark-primary-color: @dark-blue;\n    --blue: @blue;\n    --error: @cherry;\n};","@font-face {\n    font-weight: normal;\n    font-style: normal;\n    font-family: 'SB Sans Text';\n    src: url('assets/fonts/SB Sans Text.woff2') format('woff2'), url('assets/fonts/SB Sans Text.woff') format('woff');\n    font-display: swap;\n}\n\n@font-face {\n    font-weight: bold;\n    font-style: normal;\n    font-family: 'SB Sans Text';\n    src: url('assets/fonts/SB Sans Text Bold.woff2') format('woff2'), url('assets/fonts/SB Sans Text Bold.woff') format('woff');\n    font-display: swap;\n}\n\n@font-face {\n    font-weight: normal;\n    font-style: normal;\n    font-family: 'SB Sans Interface';\n    src: url('assets/fonts/SB Sans Interface.woff2') format('woff2'), url('assets/fonts/SB Sans Interface.woff') format('woff');\n    font-display: swap;\n}\n\n@font-face {\n    font-weight: 600;\n    font-style: normal;\n    font-family: 'SB Sans Interface';\n    src: url('assets/fonts/SB Sans Interface Bold.woff2') format('woff2'), url('assets/fonts/SB Sans Interface Bold.woff') format('woff');\n    font-display: swap;\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
